import { paths } from '@/lib/paths';
import { queryStringEncrypted } from '@/lib/util';
import { serviceRequestActions } from '@/states/serviceRequestState';

import { useRouter } from './useRouter';

export const useService = () => {
  const { push } = useRouter();
  const navToServiceRequest = (sn?: string, clear = true) => {
    if (clear) {
      serviceRequestActions.clear();
    }
    if (sn) {
      return push(
        paths.service.request.url({
          query: {
            q: queryStringEncrypted({
              sn,
            }),
          },
        }),
      );
    } else {
      return push(paths.service.request.url());
    }
  };
  return {
    navToServiceRequest,
  };
};
